import { useWSMutation } from "../../helpers";
import { QUERY_SHARED_FILE } from "../keys";
import { ISharedFileRequestResponse } from "@wingspanhq/shared-files/dist/lib/interfaces";
import { WSServiceError } from "../../../utils/serviceHelper";
import { submitSharedFile } from "../../../services/sharedFile/submitSharedFile";
import { queriesNotifications, queriesPayerEngagements } from "@query";

type SubmitSharedFilePayload = {
  sharedFileId: string;
};

export const useMutationSubmitSharedFile = () =>
  useWSMutation<
    ISharedFileRequestResponse,
    WSServiceError,
    SubmitSharedFilePayload
  >(({ sharedFileId }) => submitSharedFile(sharedFileId), {
    dependencies(payload) {
      return [
        [QUERY_SHARED_FILE, payload.sharedFileRequestId],
        queriesNotifications.listNotifications.queryKeyBase,
        // v3: this requirement action can affect the payer-engagement it's
        // scoped to (requirements/QBO shown there) — invalidate rather than
        // eagerly re-fetch, since the caller's payerId shape (v1 or v3) isn't
        // known here.
        queriesPayerEngagements.getPayerEngagement.queryKeyBase,
        queriesPayerEngagements.listPayerEngagements.queryKeyBase
      ];
    }
  });
